// Do not export colors directly, use the palette colors instead
const colors = {
	common: {
		black: '#000000',
		white: '#FFFFFF',
	},
	anchor: {
		100: '#E5EDF8',
		200: '#B6CFF5',
		300: '#89B2F0',
		400: '#407BD2',
		500: '#004BB9',
		600: '#07469C',
		700: '#0C3F81',
		800: '#0F3767',
		900: '#002855',
	},
	harbor: {
		100: '#E9F0F5',
		200: '#CEDBE8',
		300: '#98B3CD',
		400: '#5F8CB3',
		500: '#216D9E',
		600: '#1C5D86',
		700: '#174D6F',
		800: '#123C57',
		900: '#0D2C3F',
	},
	grove: {
		100: '#EFF6F4',
		200: '#C7DDD7',
		300: '#85B3A6',
		400: '#458C78',
		500: '#1B765D',
		600: '#0E6B51',
		700: '#14604B',
		800: '#135240',
		900: '#0D3C2E',
	},
	ember: {
		100: '#FAEDEE',
		200: '#F4C9CA',
		300: '#E5848B',
		400: '#CA4A59',
		500: '#B94450',
		600: '#A23B47',
		700: '#832E38',
		800: '#68252D',
		900: '#511E24',
	},
	charcoal: {
		50: '#F6F6F6',
		100: '#EFEFEF',
		200: '#DADADA',
		300: '#AFAFAF',
		400: '#848484',
		500: '#656565',
		600: '#5B5A5A',
		700: '#4D4D4D',
		800: '#383838',
		900: '#282828',
	},
	dune: {
		50: '#F8F7F4',
		100: '#F3F1EA',
		200: '#DDDCD5',
		300: '#BBBAB4',
		400: '#8C8A81',
		500: '#6C695B',
		600: '#5B584D',
		700: '#4B493E',
		800: '#3B392F',
		900: '#2F2D25',
	},
	red: {
		100: '#FEE4E2',
		200: '#FECDCA',
		300: '#FDA29B',
		400: '#F97066',
		500: '#F04438',
		600: '#D92D20',
		700: '#B42318',
		800: '#7A271A',
		900: '#55160C',
	},
	amber: {
		100: '#FEF0C7',
		200: '#FEDF89',
		300: '#FEC84B',
		400: '#FDB022',
		500: '#F79009',
		600: '#DC6803',
		700: '#B54708',
		800: '#7A2E0E',
		900: '#4E1D09',
	},
	green: {
		100: '#DCFAE6',
		200: '#ABEFC6',
		300: '#75E0A7',
		400: '#47CD89',
		500: '#17B26A',
		600: '#079455',
		700: '#067647',
		800: '#085D3A',
		900: '#053321',
	},
	violet: {
		100: '#E8E2FE',
		200: '#D9CAFE',
		300: '#B89BFD',
		400: '#9966F9',
		500: '#8238F0',
		600: '#7320D9',
		700: '#6118B4',
		800: '#471A7A',
		900: '#370C55',
	},
} as const;

const { common, charcoal, anchor, harbor, ember, grove } = colors;

export const textColors = {
	primary: charcoal[500],
	secondary: charcoal[900],
	tertiary: charcoal[700],
	brand: anchor[500],
	disabled: charcoal[300],
	accent1: harbor[500],
	accent2: grove[500],
	accent3: ember[500],
	light: common.white,
	contrastText: common.white,
} as const;
